import { CommoditySection, SidebarEnum } from './types';

export const CommoditySectionData: CommoditySection = {
  cable: [
    {
      title: 'Details',
      path: 'details',
      id: 'details',
      status: SidebarEnum.FILLED,
      children: [
        { title: 'Equipment Details', status: SidebarEnum.NOT_FILLED, path: '', id: 'equipmentDetails' },
        { title: 'Miscellaneous Data', status: SidebarEnum.NOT_FILLED, path: '', id: 'miscellaneousData' },
      ],
    },
    {
      title: 'Terminations',
      path: 'terminations',
      statusProp: 'hasTerms',
      status: SidebarEnum.NOT_FILLED,
    },
    {
      title: 'Routing',
      path: 'routing',
      statusProp: 'hasVias',
      status: SidebarEnum.NOT_FILLED,
    },
    {
      title: 'Reels',
      path: 'reels',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasReels',
      displayMemberName: 'reel',
    },
    {
      title: 'Packages',
      path: 'packages',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasPackages',
      displayMemberName: 'package',
    },
    {
      title: 'Notes',
      path: 'notes',
      statusProp: 'hasCableNotes',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'cableNote',
    },
  ],
  raceway: [
    {
      title: 'Details',
      path: 'details',
      id: 'details',
      status: SidebarEnum.FILLED,
      children: [
        {
          title: 'Miscellaneous Data',
          path: '',
          id: 'miscellaneousData',
          status: SidebarEnum.NOT_FILLED,
        },
      ],
    },
    {
      title: 'Barriers',
      path: 'barriers',
      status: SidebarEnum.NOT_FILLED,
    },
    {
      title: 'Cables',
      path: 'cables',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'cable',
    },
    {
      title: 'Linkages',
      path: 'links',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasLinks',
    },
    {
      title: 'Fire Wrap',
      path: 'wraps',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasRacewayWrap',
    },
    {
      title: 'Packages',
      path: 'packages',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'package',
      statusProp: 'hasPackages',
    },
    {
      title: 'Notes',
      path: 'notes',
      statusProp: 'hasNotes',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'racewayNote',
    },
  ],
  equipment: [
    {
      title: 'Details',
      path: 'details',
      id: 'details',
      status: SidebarEnum.FILLED,
      children: [{ title: 'Miscellaneous Data', status: SidebarEnum.NOT_FILLED, path: '', id: 'miscellaneousData' }],
    },
    {
      title: 'Blocks',
      path: 'blocks',
      statusProp: 'hasBlocks',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'equipmentBlock',
    },
    {
      title: 'Cables',
      path: 'cables',
      statusProp: 'numberOfCables',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'cable',
    },
    {
      title: 'Jumpers',
      path: 'jumpers',
      statusProp: 'numberOfJumpers',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'jumper',
    },
    {
      title: 'Linkages',
      path: 'links',
      statusProp: 'hasLinks',
      status: SidebarEnum.NOT_FILLED,
    },
    {
      title: 'Terminations',
      path: 'terminations',
      statusProp: 'hasTerms',
      status: SidebarEnum.NOT_FILLED,
    },
    {
      title: 'Packages',
      path: 'packages',
      statusProp: 'hasPackages',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'package',
    },
    {
      title: 'Notes',
      path: 'notes',
      statusProp: 'hasNotes',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'equipmentNote',
    },
  ],
  jumper: [
    {
      title: 'Details',
      path: 'details',
      id: 'details',
      status: SidebarEnum.FILLED,
      children: [
        {
          title: 'Equipment Details',
          path: '',
          id: 'equipmentDetails',
          status: SidebarEnum.NOT_FILLED,
        },
        {
          title: 'Miscellaneous Data',
          path: '',
          id: 'miscellaneousData',
          status: SidebarEnum.NOT_FILLED,
        },
      ],
    },
    {
      title: 'Terminations',
      path: 'terminations',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasTerms',
    },
    {
      title: 'Packages',
      path: 'packages',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'package',
      statusProp: 'hasPackages',
    },
    {
      title: 'Notes',
      path: 'notes',
      statusProp: 'hasNotes',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'jumperNote',
    },
  ],
  'cable-code': [
    {
      title: 'Details',
      path: 'details',
      id: 'details',
      status: SidebarEnum.FILLED,
      children: [
        {
          title: 'Materials',
          path: '',
          id: 'materials',
          status: SidebarEnum.NOT_FILLED,
        },
        {
          title: 'Miscellaneous Data',
          path: '',
          id: 'miscellaneousData',
          status: SidebarEnum.NOT_FILLED,
        },
      ],
    },
  ],
  'cable-reels': [
    {
      title: 'Details',
      path: 'details',
      children: [{ title: 'Miscellaneous Data', status: SidebarEnum.NOT_FILLED, path: '', id: 'miscellaneousData' }],
      status: SidebarEnum.FILLED,
    },
    {
      title: 'Cables',
      path: 'cables',
      displayMemberName: 'cable',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasCables',
    },
  ],
  'raceway-codes': [
    {
      title: 'Details',
      id: 'details',
      path: 'details',
      status: SidebarEnum.FILLED,
      children: [
        {
          title: 'Miscellaneous Data',
          path: '',
          status: SidebarEnum.NOT_FILLED,
          id: 'misc',
        },
      ],
    },
  ],
  equipmentcode: [
    {
      title: 'Details',
      path: 'details',
      id: 'details',
      children: [
        { title: 'Breaker Panel', status: SidebarEnum.NOT_FILLED, path: '', id: 'breakerPanel' },
        // { title: 'Inferred Cable Defaults', status: SidebarEnum.NOT_FILLED, path: '', id: 'inferredCable' },
        // { title: 'Termination Defaults', status: SidebarEnum.FILLED, path: '' },
        { title: 'Miscellaneous Data', status: SidebarEnum.NOT_FILLED, path: '', id: 'miscellaneousData' },
      ],
      status: SidebarEnum.FILLED,
    },
    {
      title: 'Block & Points',
      path: 'blocks',
      status: SidebarEnum.NOT_FILLED,
      displayMemberName: 'equipmentBlock',
      statusProp: 'hasBlocks',
    },
  ],
  colorCode: [
    {
      title: 'Details',
      path: 'details',
      status: SidebarEnum.FILLED,
    },
  ],
  fireArea: [
    {
      title: 'Details',
      path: 'details',
      status: SidebarEnum.FILLED,
    },
  ],
  package: [
    {
      title: 'Details',
      path: 'details',
      status: SidebarEnum.FILLED,
    },

    {
      title: 'Cable',
      path: 'cables',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasCables',
    },
    {
      title: 'Raceway',
      path: 'raceways',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasRaceways',
    },
    {
      title: 'Equipment',
      path: 'equipments',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasEquipment',
    },
    {
      title: 'Jumper',
      path: 'jumpers',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasJumpers',
    },
    {
      title: 'Terminations',
      path: 'terminations',
      status: SidebarEnum.NOT_FILLED,
      statusProp: 'hasTerms',
    },
    {
      title: 'Associated Packages',
      path: 'associated-packages',
      statusProp: 'associatedPackages',
      status: SidebarEnum.NOT_FILLED,
    },
  ],
};
